module.exports = __webpack_public_path__ + "img/linkedin.5c92d783.svg";